import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket | null {
  return socket;
}

export async function connectSocket(): Promise<Socket | null> {
  if (socket?.connected) return socket;
  try {
    const { default: api } = await import('./api');
    const { data } = await api.post('/auth/socket-token');
    const token = data.token as string;
    if (!token) return null;

    const base = import.meta.env.VITE_API_URL
      ? import.meta.env.VITE_API_URL.replace(/\/+$/, '')
      : '';

    socket = io(base || undefined, {
      path: '/socket.io/',
      withCredentials: true,
      auth: { token },
      transports: ['websocket', 'polling'],
    });
    return socket;
  } catch (e) {
    console.warn('Socket connect skipped:', e);
    return null;
  }
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}
